import { makeObservable, observable, computed } from 'mobx';
import ElectionsModule from 'store/modules/elections/electionsModule';
import SubscriberDelegate from 'store/modules/elections/subscriberDelegate';
import SubDependentDelegate from 'store/modules/elections/dependents/subDependentDelegate';

export interface IDependentsTabPageStore {
  readonly isInitialDataLoading: boolean;
  readonly electionsModule: ElectionsModule;
}

export default class DependentsTab {
  private _pageStore: IDependentsTabPageStore;
  private _getDependentFormId: () => string | undefined;

  public getDependentFormId(): string | undefined {
    return this._getDependentFormId();
  }

  public get subscriberDelegate(): SubscriberDelegate | undefined {
    return this._pageStore.electionsModule.subscribers[0]?.subscriberDelegate;
  }

  public get dependentDelegates(): SubDependentDelegate[] {
    return this.subscriberDelegate?.subscriberDependentsDelegates || [];
  }

  public get isLoading(): boolean {
    return this._pageStore.isInitialDataLoading;
  }

  constructor(pageStore: IDependentsTabPageStore, getDependentFormId: () => string | undefined) {
    this._pageStore = pageStore;
    this._getDependentFormId = getDependentFormId;

    makeObservable<DependentsTab, '_pageStore' | '_getDependentFormId'>(this, {
      _pageStore: observable,
      _getDependentFormId: observable,
      subscriberDelegate: computed,
      dependentDelegates: computed,
      isLoading: computed,
    });
  }
}
